module.exports = __webpack_public_path__ + "img/reso_product.1f019b2d.jpg";